(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gentleman-visit"] && !Shopify.designMode) return;
  try {
    (function(){
 const root=document.querySelector('[data-gentleman-visit]');if(!root)return;
 const button=root.querySelector('[data-show-booking]');
 function showBooking(focus){root.classList.add('sg-booking-open');button.setAttribute('aria-expanded','true');if(focus){root.querySelector('#sg-visit-booking').focus();root.querySelector('#sg-visit-booking').scrollIntoView({block:'start'});}}
 button.addEventListener('click',function(){showBooking(true);});
 root.querySelectorAll('input[name="sg-visit-purpose"]').forEach(function(input){input.addEventListener('change',function(){root.classList.remove('sg-booking-open');button.setAttribute('aria-expanded','false');});});
 const params=new URLSearchParams(location.search);
 if(root.dataset.defaultService==='camisas'&&params.get('reserva')==='1')showBooking(false);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snip-custom-contact"] && !Shopify.designMode) return;
  try {
    (function(){var field=document.getElementById('contactFormService');if(!field)return;var service=new URLSearchParams(location.search).get('servicio');var choices={trajes:'Trajes a medida',camisas:'Camisas a medida',otros:'Información y otros servicios'};if(choices[service])field.value=choices[service];})();
  } catch(e) { console.error(e); }
})();

})();
